import React, { useEffect, useState } from "react";
import authProvider, { getAccessExpiration } from "../authProvider.js";
import ConfirmModal from "./ConfirmModal";
import { useTranslation } from "react-i18next";

const TokenExpiryPopup = () => {
  const { t } = useTranslation();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [remainingTime, setRemainingTime] = useState(300);

  const checkTokenExpiration = async () => {
    // Read expiration from cookie instead of localStorage
    const expirationTimeStr = getAccessExpiration();
    if (!expirationTimeStr) {
      // No cookie means user is not logged in
      return;
    }

    const expirationTime = parseInt(expirationTimeStr, 10);
    const currentTime = Math.floor(new Date().getTime() / 1000);
    const timeLeft = expirationTime - currentTime;
    setRemainingTime(timeLeft);

    // Show warning popup when less than 5 minutes remain
    if (timeLeft <= 300 && timeLeft > 0) {
      setIsPopupVisible(true);
    }

    // Auto logout when token expires
    if (timeLeft <= 0) {
      await authProvider.logout();
      window.location.href = "/user/login";
    }
  };

  useEffect(() => {
    const intervalId = setInterval(checkTokenExpiration, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const handleExtendSession = () => {
    authProvider
      .refreshToken()
      .then(() => {
        setIsPopupVisible(false);
        // Reset remaining time after successful refresh
        setRemainingTime(300);
      })
      .catch(async (error) => {
        alert("Failed to extend session. Please log in again.");
        await authProvider.logout();
        window.location.href = "/user/login";
      });
  };

  const minutes = Math.floor(remainingTime / 60);
  const seconds = String(remainingTime % 60).padStart(2, "0");

  return isPopupVisible ? (
    <ConfirmModal
      title={
        <div>
          {t("Warning")}!
          <br />
          <span
            style={{
              display: "inline-block",
              border: "1px solid var(--color-primary)",
              padding: "0 10px",
              marginTop: "10px",
            }}
          >
            {minutes}:{seconds}
          </span>
        </div>
      }
      question={t(
        `Your session will expire. To continue your session, click the 'Keep me logged in' button below.`
      )}
      onConfirm={handleExtendSession}
      confirmButtonText={t("Keep me logged in")}
    />
  ) : null;
};

export default TokenExpiryPopup;
